module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "section",
    attrs: {
      "id": "section008"
    }
  }, [_c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "poem_title1",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Circular the table for eating, around which we talked.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Golden branches vaulted the roads.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("The trip to Colorado had already been planned.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Otherwise, I would never have left.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Maybe you know my friend.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Spectra inside spectra make cataclysm of day.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Something like that. Disorder in all things.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Mother, I won’t call to complain anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("The geraniums are enormous. Bougainvilleas crowd the walls.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Given a box, some people imagine a hammer and nails.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("In some kinds of poems, the arms are love.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("The day I ran with Dan at the reservoir,")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("I hated how slow I was, but loved that my lungs could burn.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Many years ago in school a visiting poet read my poem.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("I said I didn’t know what the poem was.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Of course you do, she said.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755006d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter002.vue
// module id = 87
// module chunks = 0